import { configureStore } from '@reduxjs/toolkit'
import { api } from '../services/api'
import { authSlice } from './auth/authSlice'
import { shopOrderSlice } from './shop_order/shopOrderSlice'
import { currentOrderSlice } from './current_order/currentOrderSlice'
import { selectedProductsSlice } from './selected_products/selectedProductsSlice'
import { posCartSlice } from './pos_cart/posCartSlice'
import { ticketSlice } from './ticket/ticketSlice'
import { ordersFiltersSlice } from './orders_filters/orders_filters'
import { dialogsSlice } from './dialogs/dialogsSlice'
import { currentReportDataSlice } from './current_report_data/currentReportDataSlice'
import { localesSlice } from './locales/locales'

export const store = configureStore({
    reducer: {
        api: api.reducer,
        auth: authSlice.reducer,
        shopOrder: shopOrderSlice.reducer,
        currentOrder: currentOrderSlice.reducer,
        selectedProducts: selectedProductsSlice.reducer,
        posCart: posCartSlice.reducer,
        ticket: ticketSlice.reducer,
        ordersFilters: ordersFiltersSlice.reducer,
        dialogs: dialogsSlice.reducer,
        currentReportData: currentReportDataSlice.reducer,
        locales: localesSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(api.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
